import { Answer, SelectedRoom } from "../types/types";

export const checkAdressAnswer = (
  selectedRoom: SelectedRoom | null,
  task: Answer,
) => {
  if (!selectedRoom || !task.position) return false;

  return (
    selectedRoom.column === task.position.column &&
    5 - selectedRoom.roomId === task.position.roomId
  );
};